import React from "react";

import { useUpdateUrlParams } from "hooks/useUpdateUrlParams";
import type { DashboardUIType } from "types/BusinessDashboard";

import { SalesDashboard } from "./sales-dashboard/sales-dashboard";
import { MembersDashboard } from "./members-dashboard/members-dashboard";
import { RealtimeDashboard } from "./realtime-dashboard/realtime-dashboard";

export const DashboardRouter = () => {
  const { searchParams } = useUpdateUrlParams();
  const currentPage = (searchParams.get("view") ??
    "realtime") as DashboardUIType;

  switch (currentPage) {
    case "realtime":
      return <RealtimeDashboard />;
    case "sales":
      return <SalesDashboard />;
    case "members":
      return <MembersDashboard />;
  }
};
